import React, { useEffect, useState } from "react";
import { useIframeUrlMutation } from "../../app/services/DashBoard/adminDashBoardApi";
import { formatISO } from "date-fns";


const MetaBaseDashBoardSeven = () => {
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [iframeUrlApi] = useIframeUrlMutation();

  const [eventStartDate, setEventStartDate] = useState(null);
  const [eventEndDate, setEventEndDate] = useState(null);
  const [courseApprovedStartDate, setCourseApprovedStartDate] = useState(null);
  const [courseApprovedEndDate, setCourseApprovedEndDate] = useState(null);

  const fetchIframeUrl = async (withFilter = false) => {
    setLoading(true);
    setError("");

    try {
      const params = {};

      if (withFilter) {
        // Event date range
        if (eventStartDate) {
          params.event_start_date = toApiDate(eventStartDate);
        }
        if (eventEndDate) {
          params.event_end_date = toApiDate(eventEndDate);
        }

        // Course approved date range
        if (courseApprovedStartDate) {
          params.course_approval_start_date = toApiDate(courseApprovedStartDate);
        }
        if (courseApprovedEndDate) {
          params.course_approval_end_date = toApiDate(courseApprovedEndDate);
        }
      }

      const requestPayload = {
        QuestionId: 52,
        params,
        expMinutes: 0,
        bordered: false,
        titled: true,
      };

      const response = await iframeUrlApi(requestPayload).unwrap();
      setIframeUrl(response.iframeUrl);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch dashboard data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIframeUrl();
  }, []);

  const resetForm = () => {
    setEventStartDate(null);
    setEventEndDate(null);
    setCourseApprovedStartDate(null);
    setCourseApprovedEndDate(null);;
    fetchIframeUrl(false);
  };

  const toApiDate = (date) =>
    date ? formatISO(date, { representation: "date" }) : null;

  return (
    <div style={{ position: "relative", padding: "20px" }}>
      <div className="iframe-card iframe-card-filter-sec" style={{ marginBottom: "16px" }}>
        <div className="iframe-card">
          {/* {Event Start- end date } */}
          <div >
            <label style={{ display: "block", marginBottom: "4px" }}>
              Event Start Date
            </label>
            <input
              type="date"
              value={
                eventStartDate ? formatISO(eventStartDate, { representation: "date" }) : ""
              }
              onChange={(e) =>
                setEventStartDate(e.target.value ? new Date(e.target.value) : null)
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px"
              }}
            />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: "4px" }}>
              Event End Date
            </label>
            <input
              type="date"
              value={
                eventEndDate ? formatISO(eventEndDate, { representation: "date" }) : ""
              }
              onChange={(e) =>
                setEventEndDate(e.target.value ? new Date(e.target.value) : null)
              }
              min={
                eventStartDate
                  ? formatISO(eventStartDate, { representation: "date" })
                  : undefined
              } style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px"

              }}
            />
          </div>

          {/* {Event Start- end date } */}
          <div>
            <label style={{ display: "block", marginBottom: "4px" }}>
              Course Approved Start Date
            </label>
            <input
              type="date"
              value={
                courseApprovedStartDate ? formatISO(courseApprovedStartDate, { representation: "date" }) : ""
              }
              onChange={(e) =>
                setCourseApprovedStartDate(e.target.value ? new Date(e.target.value) : null)
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px"

              }}
            />
          </div>
          <div>
            <label style={{ display: "block", marginBottom: "4px" }}>
              Course Approved End Date
            </label>
            <input
              type="date"
              value={
                courseApprovedEndDate ? formatISO(courseApprovedEndDate, { representation: "date" }) : ""
              }
              onChange={(e) =>
                setCourseApprovedEndDate(e.target.value ? new Date(e.target.value) : null)
              }
              min={
                courseApprovedStartDate
                  ? formatISO(courseApprovedStartDate, { representation: "date" })
                  : undefined
              }
              style={{
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                width: "250px"
              }}
            />
          </div>
          <button
            onClick={() => fetchIframeUrl(true)}
            disabled={loading}
            style={{
              backgroundColor: "#ff8c00",
              color: "white",
              border: "none",
              padding: "8px 16px",
              borderRadius: "6px",
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Loading..." : "Fetch"}
          </button>
        </div>
        <button
          onClick={resetForm}
          class="btn success-btn reload-btn"
          disabled={loading}
          style={{
            cursor: loading ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "Loading..." : "Reload Report"}
        </button>

      </div>

      {loading && <p>Loading report...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="pie-chart-card">
        {iframeUrl ? (
          <iframe
            src={iframeUrl}
            width="100%"
            height="500"
            frameBorder="0"
            style={{ borderRadius: "8px" }}
            title="Metabase Report 51"
          />
        ) : (
          <p style={{ textAlign: "center" }}>No data loaded yet</p>
        )}
      </div>
    </div>
  );
};

export default MetaBaseDashBoardSeven;
